import React, { useEffect, useState } from "react";
import { Grid, Card, Typography, Box, Avatar, IconButton } from "@mui/material";
import { useDrop } from "react-dnd";

import { $crud } from "../../../utils/CrudFactory";
import { Close } from "@mui/icons-material";
import reviewimg1 from "../../../assets/images/top-review-1.png";
import reviewimg2 from "../../../assets/images/top-review-2.png";
import reviewimg3 from "../../../assets/images/top-review-3.png";
import StarIcon from "@mui/icons-material/Star";
import { toLocalTime } from "../../../helper/functions";

const revimg = {
  1: reviewimg1,
  2: reviewimg2,
  3: reviewimg3,
};

const TopReviewDriver = () => {
  const [topReviews, setTopReviews] = useState([]);
  const [, drop] = useDrop(
    () => ({
      accept: "review",
      drop: async (item) => {
        try {
          const { data: topData } = await $crud.post(
            "admin/top-driver-review",
            {
              orderId: item.orderId,
            }
          );
          setTopReviews(topData.topDriverReview);
        } catch (e) {
          console.error(e);
        }
      },
    }),
    [topReviews]
  );

  useEffect(() => {
    async function fetchReviews() {
      try {
        const { data } = await $crud.retrieve("admin/top-driver-reviews");
        setTopReviews(data.topdriverReviews);
      } catch (e) {}
    }
    fetchReviews();
  }, []);

  const handleDelete = async (review) => {
    try {
      const { data } = await $crud.delete("admin/top-driver-review", {
        orderId: review.reviewId,
        id: review._id,
      });
      setTopReviews(data.topdriverReviews);
    } catch (e) {
      console.error(e);
    }
  };

  const sortedRev = topReviews
    .sort((a, b) => Number(b.rating) - Number(a.rating))
    .slice(0, 3);
  const displayReviews =
    sortedRev.length < 3
      ? [
          ...sortedRev,
          ...Array.from({ length: 3 - sortedRev.length }, (_) => ({
            title: "NO REVIEW",
          })),
        ]
      : sortedRev;

  return (
    <Grid container spacing={2} ref={drop} sx={{ mt: "1px" }}>
      {displayReviews.length === 0 ? (
        <Grid item xs={12}>
          <Card
            sx={{
              position: "relative",
              padding: "18px",
              height: "260px",
              width: "100%",
              background: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                width: "100%",
                color: "#A3A3A3",
              }}
            >
              No top driver reviews found
            </Typography>
          </Card>
        </Grid>
      ) : (
        displayReviews.map((review, index) =>
          review.title === "NO REVIEW" ? (
            <Grid item xs={12} md={4} key={index}>
              <Card
                sx={{
                  position: "relative",
                  padding: "18px",
                  height: "280px",
                  background: "#683C8C33",
                  color: "#000000",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Top Review By Driver
              </Card>
            </Grid>
          ) : (
            <Grid item xs={12} md={4} key={index}>
              <Card
                sx={{
                  position: "relative",
                  padding: "18px",
                  height: "280px",
                  background: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <IconButton
                  onClick={() => handleDelete(review)}
                  sx={{
                    position: "absolute",
                    right: "8px",
                    top: "8px",
                    color: "rgba(104, 60, 140)",
                    // color: "#fff",
                    "&:hover": {
                      background: "rgba(104, 60, 140, 0.35)",
                    },
                  }}
                >
                  <Close />
                </IconButton>
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <img
                    src={revimg[index + 1]}
                    alt="review"
                    style={{ width: "115px", height: "99px" }}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    // padding:"",

                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "8px",
                        color: "#683C8C",
                        fontWeight: 400,
                      }}
                    >
                      Date of Submission :{" "}
                      <span
                        style={{
                          color: "#979797",
                        }}
                      >
                        {toLocalTime(review.date)}
                      </span>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "9px",
                        color: "#171A1F",
                        fontWeight: 400,
                        marginTop: "2px",
                      }}
                    >
                      {review.title}
                    </Typography>
                  </Box>
                </Box>

                <Box
                  sx={{
                    background: "#683C8C",
                    borderRadius: "4px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    padding: "17px",
                    paddingX: "20px",
                    height: "78px",
                    marginTop: "10px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <Avatar src={review.img} sx={{ width: "44px" }} />
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: "#fff",
                          fontWeight: 600,
                        }}
                      >
                        {review.author}
                      </Typography>
                      <Typography sx={{ fontSize: "9px", color: "#BDC1CA" }}>
                        {review.city || "NA"}
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <StarIcon
                      sx={{ width: "23px", height: "23px", color: "#F7C705" }}
                    />
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#fff",
                        fontWeight: 400,
                      }}
                    >
                      {review.rating}
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>
          )
        )
      )}
    </Grid>
  );
};

export default TopReviewDriver;
